import styled, { css } from 'styled-components';
import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';
import off from './images/check-off.svg'
import on from './images/check-on.svg'

export const Wrap = styled.div`
  position: relative;
`;

export const ButtonWrap = styled.div`
  position: absolute;
  width: 73%;
  top: 90%;
  left: 12%;
`;

export const NoticWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 6%;

  > div + div {
    margin-top: 2%;
  }
`;

export const Label = styled.label`
  display: contents;
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #0066ec;
  letter-spacing: -1px;
`;

export const Checkbox = styled.input`
  ${checkboxStd};
  /* border: 4px solid blue; */

  background: #fff url(${off}) center center no-repeat;

  &:checked {
    background-image: url(${on});
  }

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;


export const ArrowWrap = styled.div`
  margin-left: 3%;
  padding-top: 2%;

  svg {
    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const BoxWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
